/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";
import { useScrollSpy } from "hooks/useScrollSpy";

const getActiveColorByRoute = (routePath) => {
  if (routePath.includes("history")) return "#2458EA";
  if (routePath.includes("friend")) return "#68349A";
  return "#059212";
};

export function SidebarLinks(props) {
  //   Chakra color mode
  const { routes } = props;
  const activeSection = useScrollSpy(routes);
  let location = useLocation();
  let activeColor = getActiveColorByRoute(activeSection);
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");


  // Debug log
  console.log("Current location:", location.pathname, location.hash);
  console.log("Active section:", activeSection);

  // verifies if routeName is the one active
  const activeRoute = (routePath) => {
    // Handle routes dengan hash (section dalam halaman yang sama)
    if (routePath && routePath.includes("#")) {
      const [path, hash] = routePath.split("#");

      // Cek apakah sedang di path yang benar
      const isOnCorrectPath = location.pathname.includes(path);

      if (isOnCorrectPath) {
        // Prioritas: scroll spy detection
        if (activeSection === hash) {
          return true;
        }

        // Fallback: jika ada hash di URL yang cocok
        if (location.hash === `#${hash}`) {
          return true;
        }
      }
      return false;
    }

    // Handle routes tanpa hash (navigasi biasa)
    const isOnPath = location.pathname.includes(routePath);

    // Khusus untuk route Profile: aktif jika di halaman profile tapi tidak ada section yang aktif
    if (routePath === "/profile" && isOnPath) {
      // Profile aktif jika tidak ada section yang aktif dari scroll spy
      return !activeSection;
    }

    return isOnPath;
  };

  // Handle navigation
  const handleNavigation = (route) => {
    if (route.path && route.path.includes("#")) {
      const [path, hash] = route.path.split("#");

      // Jika sudah di halaman yang benar, scroll ke section
      if (location.pathname.includes(path)) {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        // Update URL hash
        window.history.pushState(null, null, `#${hash}`);
      } else {
        // Jika belum di halaman yang benar, navigate dulu
        // React Router akan handle ini
        return true; // Biarkan NavLink handle navigation
      }
      return false; // Prevent NavLink navigation
    }
    return true; // Biarkan NavLink handle navigation normal
  };

  // this function creates the links from the secondary accordions
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        return (
          <React.Fragment key={index}>
            <Text
              fontSize={"md"}
              color={activeColor}
              fontWeight="bold"
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              pt="18px"
              pb="12px"
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </React.Fragment>
        );
      } else if (route.layout === "/dashboard" || route.layout === "/auth") {
        const isActive = activeRoute(route.path);

        return (
          <NavLink
            key={index}
            to={route.layout + route.path}
            onClick={(e) => {
              const shouldPreventDefault = !handleNavigation(route);
              if (shouldPreventDefault) {
                e.preventDefault();
              }
            }}
          >
            {route.icon ? (
              <Box>
                <HStack spacing={isActive ? "22px" : "26px"} py="5px" ps="10px">
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box color={isActive ? activeIcon : textColor} me="18px">
                      {route.icon}
                    </Box>
                    <Text
                      color={isActive ? activeColor : textColor}
                      fontWeight={isActive ? "bold" : "normal"}
                    >
                      {route.name}
                    </Text>
                  </Flex>
                  <Box
                    h="36px"
                    w="4px"
                    bg={isActive ? brandColor : "transparent"}
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={isActive ? "22px" : "26px"}
                  py="5px"
                  ps="10px"
                  justifyContent="end"
                >
                  <Text
                    color={isActive ? activeColor : inactiveColor}
                    fontWeight={isActive ? "bold" : "normal"}
                  >
                    {route.name}
                  </Text>
                  <Box
                    h="36px"
                    w="4px"
                    bg={isActive ? brandColor : "transparent"}
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
      return null;
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
